export const state = () => ({
  pending: 0,
  since: 0,
})

export const mutations = {
  start(state) {
    if (state.pending === 0) state.since = Date.now()
    state.pending++
  },
  finish(state) {
    if (state.pending > 0) state.pending--
  },
  reset(state) {
    state.pending = 0
    state.since = 0
  },
}

export const getters = {
  isLoading: (state) => state.pending > 0,
  pendingSince: (state) => state.since,
}
